import React from "react";
import { Container } from "reactstrap";
import { Helmet } from 'react-helmet-async';
import Section from "./Section";
import AddFormSec from "./AddFormSec";

const AddNewCompany = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Add New Company | Jobseekers Page </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
          <AddFormSec />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AddNewCompany;
